import React, { useState } from "react";
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from "react-tooltip";
import Select from "react-select";

const STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "In-Process", value: "In-Process" },
  { label: "Rejected", value: "Rejected" },
  { label: "Completed", value: "Completed" },
];

const SegmentRequestList = ({
  tableData,
  onSort,
  loader,
  updateStatus,
  onView,
  onEdit,
}) => {
  // const toggleDealStatus = (e, id) => {
  //     if (e.target.checked) {
  //         updateDealStatus({ id: id, status: 1 });
  //     } else {
  //         updateDealStatus({ id: id, status: 0 });
  //     }
  // }

  const handleSort = (column) => {
    onSort(column);
  };

  const handleStatusChange = (selectedOption, row) => {
    if (!selectedOption) return;

    console.log("HI");
    console.log(row);
    updateStatus({
      id: row.id,
      status: selectedOption.value,
    });
  };

  const getSelectedStatus = (status) =>
    STATUS_OPTIONS.find((opt) => opt.value === status) || null;
  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="srno">Sr. No.</th>
              <th className="partner" onClick={() => handleSort("refCode")}>
                Ref. Code <i className="fas fa-sort"></i>
              </th>

              <th className="email" onClick={() => handleSort("email")}>
                Email <i className="fas fa-sort"></i>
              </th>
              
              <th className="partner" onClick={() => handleSort("dsp_name")}>
                DSP Name <i className="fas fa-sort"></i>
              </th>
              <th className="deal-name" onClick={() => handleSort("dealName")}>
                Deal Name <i className="fas fa-sort"></i>
              </th>
              <th className="margin" onClick={() => handleSort("margin")}>
                Margin <i className="fas fa-sort"></i>
              </th>
              <th className="margin" onClick={() => handleSort("cpm")}>
                CPM <i className="fas fa-sort"></i>
              </th>
              <th onClick={() => handleSort("updated_on")} className="margin">
                Request On <i className="fas fa-sort"></i>{" "}
              </th>
              {/* <th className="action">Comment</th> */}
              <th onClick={() => handleSort("status")} className="statusdropdown">
                Status <i className="fas fa-sort"></i>{" "}
              </th>
              <th className="status">Actions</th>
            </tr>
          </thead>
          <>
            {!loader ? (
              <tbody>
                {tableData && tableData.length > 0 ? (
                  tableData?.map((item, i) => (
                    <tr key={i}>
                      <td className="srno">{i + 1}</td>
                      <td className="wrap-string partner">{item?.refCode}</td>
                      <td className="wrap-string email">{item?.email}</td>
                      <td className="partner">{item?.dsp_name}</td>
                      <td className="deal-name">{item?.dealName}</td>
                      <td className="margin">{item?.margin}</td>
                      <td className="margin">{item?.cpm}</td>

                      <td className="margin">{item?.updated_on}</td>
                      {/* <td className="text-center action">{item?.comment}</td> */}

                      {/* ✅ STATUS DROPDOWN */}
                      <td className="statusdropdown">
                        <Select
                          className="tableSelect"
                          value={getSelectedStatus(item?.status)}
                          options={STATUS_OPTIONS}
                          isSearchable={false}
                          onChange={(e) => handleStatusChange(e, item)}
                        />
                      </td>
                      <td className="text-center status">
                        <div className="table-icons">
                          <i
                            className="fa-regular fa-eye blue"
                            onClick={() => onView(item)}
                          ></i>
                          <i
                            className="fa-regular fa-envelope green"
                            onClick={() => onEdit(item)}
                            style={{ cursor: "pointer" }}
                          ></i>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            ) : (
              <div className={`loader ${loader ? "show" : ""}`}>
                <label>
                  <img src={loaderGif} />
                </label>
              </div>
            )}
          </>
        </table>
      </div>
      <Tooltip
        id="my-tooltip-inline"
        place="top"
        style={{ backgroundColor: "rgb(182, 191, 183)", color: "#222" }}
      />
    </>
  );
};

export default SegmentRequestList;
